<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header mb-3">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("regiao") }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="fecharModal()"
                        >
                            {{ $t("cancelar") }}
                        </button>
                        <button
                            v-if="
                                (!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input 
                                :id="generateId(9)"
                                ref="idErpInput"
                                v-model="regiao.idregiaoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!regiao.idregiaoerp"
                                uppercase
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="regiao.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                tooltipLabel="informacao-descricao-regiao"
                                :tooltipMultilined="true"
                                :required="true"
                                tooltipSize="is-small"
                                msg="msg-campo-obrigatorio"
                                :invalid="!regiao.descricao"
                                uppercase
                            />
                        </div>
                        <div class="column is-5">
                            <vss-select
                                :id="generateId(2)"
                                ref="empresaSelect"
                                :searchable="false"
                                :options="empresas"
                                title="empresa"
                                tooltipLabel="informacao-empresa-regiao"
                                :tooltipMultilined="true"
                                tooltipSize="is-small"
                                :required="true"
                                v-model="empresa"
                                class="no-clear"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(3)"
                                v-model="regiao.reajustecif"
                                placeholder="placeholder-preencha"
                                :msg="msgPorcentagemInvalida"
                                title="reajuste-por-cif"
                                :invalid="invalidPorcentagemCif"
                                :onBlurFunction="validatePorcCif"
                                tooltipLabel="informacao-reajuste-cif-regiao"
                                :tooltipMultilined="true"
                                :maxlength="6"
                                ref="reajusteCifInput"
                                validchars="0123456789."
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                                icon="percent"
                                porcentagem
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(4)"
                                v-model="regiao.reajustefob"
                                placeholder="placeholder-preencha"
                                :msg="msgPorcentagemInvalida"
                                :invalid="invalidPorcentagemFob"
                                :onBlurFunction="validatePorcFob"
                                :maxlength="6"
                                ref="reajusteFobInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-reajuste-fob-regiao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                title="reajuste-por-fob"
                                tooltipSize="is-small"
                                icon="percent"
                                porcentagem
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(5)"
                                v-model="regiao.valorminimofob"
                                placeholder="placeholder-preencha"
                                ref="valorMinimoFobInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-valor-minimo-pedido-fob-regiao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                title="valor-minimo-fob"
                                tooltipSize="is-small"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(6)"
                                v-model="regiao.valorminimocif"
                                placeholder="placeholder-preencha"
                                ref="valorMinimoCifInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-valor-minimo-pedido-cif-regiao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                title="valor-minimo-cif"
                                tooltipSize="is-small"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(7)"
                                v-model="regiao.ticketmedio"
                                placeholder="placeholder-preencha"
                                ref="ticketMedioInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-ticket-medio-regiao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                title="validacao-ticket-medio"
                                tooltipSize="is-small"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(8)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="regiao.idregiao == null"
                                tooltipLabel="informacao-situacao-regiao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                title="situacao"
                                tooltipSize="is-small"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RegiaoService from "@/services/RegiaoService";
import RegiaoValidation from "@/services/validations/RegiaoValidation";
import Message from "@/models/Message";

export default {
    data() {
        return {
            usuarioIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("REGIAO"),
            isSaving: false,
            tipos: ["LPS", "Distribuídora", "Indústria", "Banderia", "Rede"],
            service: new RegiaoService(this.$http, this.$router),
            validation: null,
            regiao: {
                idregiao: null,
                idregiaoerp: null,
                idempresa: null,
                descricao: null,
                situacao: null,
                reajustecif: 0,
                reajustefob: 0,
                valorminimofob: 0,
                valorminimocif: 0,
                ticketmedio: 0,
            },
            msgs: [],
            abaSelecionada: 0,
            abas: ["dados", "contratos"],
            contratos: [],
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            situacao: { label: "ativo", id: 1 },
            isUpdate: false,
            empresas: [{ id: 0, label: this.$t("todos").toUpperCase() }],
            empresa: { id: 0, label: this.$t("todos").toUpperCase() },
            msgPorcentagemInvalida: "porcentagem-invalida",
            invalidPorcentagemCif: false,
            invalidPorcentagemFob: false,
            isLoading: false,
            isChanged: false,
            isLoadingEdit: false,
        };
    },
    watch: {
        regiao: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                }
            },
        },
    },
    created() {
        this.validation = new RegiaoValidation(this.msgs);
        this.isChanged = false;
        let empresasTemp = this.$store.state.user.empresas.map((e) => ({
            id: e.id,
            label: e.nome,
        }));
        this.empresas = this.empresas.concat(empresasTemp);

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "clientes",
            "ven-regiao"
        );
        if (!this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "regiao" },
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-modal-regiao-" + numberId;
        },
        fecharModal() {
            // @85181 - Confirmação ao fechar adicionada no modal de Região
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.$emit("fecharModal");
                    },
                });
            } else {
                this.$emit("fecharModal");
            }
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged() {
            if (!this.isLoadingEdit) this.isChanged = true;
        },
        save() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.regiao = this.mapTosave(this.regiao);
            if (this.validation.validate(this.regiao, this.$refs)) {
                this.regiao.idempresa = this.empresa.id;
                this.regiao.situacao = this.situacao.id;
                this.regiao.reajustecif =
                    this.regiao.reajustecif == "" ? 0 : this.regiao.reajustecif;
                this.regiao.reajustefob =
                    this.regiao.reajustefob == "" ? 0 : this.regiao.reajustefob;
                this.regiao.valorminimofob =
                    this.regiao.valorminimofob == ""
                        ? 0
                        : this.regiao.valorminimofob;
                this.regiao.valorminimocif =
                    this.regiao.valorminimocif == ""
                        ? 0
                        : this.regiao.valorminimocif;
                this.regiao.ticketmedio =
                    this.regiao.ticketmedio == "" ? 0 : this.regiao.ticketmedio;
                this.isSaving = true;
                this.service
                    .save(this.regiao)
                    .then((body) => {
                        if (body.content) {
                            this.$root.showMessage(
                                "success",
                                "msg-regiao-salva"
                            );
                            this.isChanged = false;
                            this.$emit("fecharModal", body.content);
                        } else {
                            if (this.$te(body.message)) {
                                if (body.message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        "alert", 
                                        this.$t(body.message, { n: this.regiao.idregiaoerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message("alert", body.message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message("error", "msg-problema-realizar-acao", true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(
                            new Message(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            )
                        );
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isChanged = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.runValidations();
                this.isLoading = false;
            }
        },
        validatePorcCif() {
            this.invalidPorcentagemCif = !this.validatePorcentagem(
                this.regiao.reajustecif
            );
        },
        validatePorcFob() {
            this.invalidPorcentagemFob = !this.validatePorcentagem(
                this.regiao.reajustefob
            );
        },

        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
    }
}
</style>